import FeedRoundedIcon from '@mui/icons-material/FeedRounded';
import { Box, FormLabel, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

const FiscalConfigBasicData = ({ onValidityChange, data, setData }) => {

    useEffect(() => {
        const isValid = data.name.trim() !== '';
        onValidityChange?.(isValid);
    },
        [data.name, onValidityChange]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <FeedRoundedIcon sx={{ color: 'primary.main' }} />
                <Typography variant='h6' sx={{ color: 'primary.main' }}>Dados Gerais</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <FormLabel sx={{ mb: 1.3, color: 'text.primary' }}><b>Nome da Configuração </b> <FormLabel sx={{ color: 'error.main' }}><b>*</b></FormLabel></FormLabel>
                <TextField
                    variant="outlined"
                    placeholder='Ex: Padrão'
                    sx={{ maxWidth: '16.5rem' }}
                    value={data.name}
                    onChange={(e) => setData({ ...data, name: e.target.value })}
                />
            </Box>
        </Box>
    );
}

export default FiscalConfigBasicData;